import { useState, useEffect } from 'react';

// Variables to manage the timer centrally
let intervalId = null;
let intervalRefCounter = 0;

const useCompletedOrdersData = () => {
  const [completedOrders, setCompletedOrders] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.0lswap.com/orders/public/completedOrders?market=OLUSDT');
        const completedOrdersData = await response.json();
        completedOrdersData.forEach((order) => {
          order.price = parseFloat(order.price);
          order.amount = parseFloat(order.amount);
          order.value = order.price * order.amount;
        });

        setCompletedOrders(completedOrdersData);
      } catch (error) {
        console.error('Failed to fetch completed orders:', error);
      }
    };

    // Increment the reference counter and create the interval if necessary
    if (intervalRefCounter === 0) {
      intervalId = setInterval(fetchData, 30000);
    }
    intervalRefCounter += 1;

    // Initial immediate call
    fetchData();

    // Cleanup function
    return () => {
      intervalRefCounter -= 1;
      if (intervalRefCounter === 0) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  return completedOrders;
};

export default useCompletedOrdersData;
